import React from 'react';
import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom';
import { connect } from 'react-redux';

import LoginPage from './pages/login/LoginPage';
import RecoveryPasswordPage from './pages/passwordRecovery/RecoveryPasswordPage';
import Main from './Main';
import Index from './Index';

import Modal from 'react-modal';
import authService from '../services/Auth';

Modal.setAppElement('#root');

function PrivateRoute({ children, ...rest }) {

  const loggedIn = authService.isAuthenticated();

  return (
    <Route
      {...rest}
      render={({ location }) => {

        if ( loggedIn ) {
          return children
        } else {
          return (
            <Redirect
              to={{
                pathname: "/login",
                state: { from: location }
              }}
            />
          )
        }
      } }
    />
  );
}

const App = ( props ) => {

  return (
     <div className="App">
       <BrowserRouter basename="/">
         <Switch>
           <PrivateRoute path='/main' > <Main /> </PrivateRoute>
           <PrivateRoute path='/index' > <Index /> </PrivateRoute>
           <Route path='/' exact> <Redirect to='/index' /> </Route>
           <Route path='/login/:t'> <LoginPage /> </Route>
           <Route path='/login'> <LoginPage /> </Route>
           <Route path='/recovery/:t'> <RecoveryPasswordPage /> </Route>
           <Route path='**'> <Redirect to="/login" /> </Route>
         </Switch>
       </BrowserRouter>
     </div>
  )
}

const mapStateToProps = ( state ) => {

  return {
    sidenavOpen: state.sidenavOpen
  }

}

export default connect( mapStateToProps )(App)
